export interface LayoutChannelSource {
  name?: string;
  thumbnail?: string;
}

export function resolveLayoutChannelSource(
  project: { youtube_channels?: Array<{ name?: string | null; thumbnail?: string | null }> | null } | null | undefined,
): LayoutChannelSource | null {
  const channel = project?.youtube_channels?.[0];
  if (!channel || typeof channel !== 'object') return null;
  const name = typeof channel.name === 'string' && channel.name.length > 0
    ? channel.name
    : undefined;
  const thumbnail = typeof channel.thumbnail === 'string' && channel.thumbnail.length > 0
    ? channel.thumbnail
    : undefined;
  if (!name && !thumbnail) return null;
  return { name, thumbnail };
}
